import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Auth0Provider } from '@auth0/auth0-react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import IPWhitelist from './components/IPWhitelist/IPWhitelist';
import { HelmetProvider } from 'react-helmet-async';

const theme = createTheme({
	components: {
		MuiAutocomplete: {
			styleOverrides: {
				noOptions: {
					color: 'white',
				},
			},
		},
	},
});

const appTree = (
	<IPWhitelist>
		<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
			<Auth0Provider
				domain="dev-v00rtojo.us.auth0.com"
				clientId="mojPBdBrWS75jXC3TqAeMrqw9Yy4Y0u3"
				redirectUri={window.location.origin}
				useRefreshTokens={true}
				cacheLocation="localstorage"
				authorizationParams={{
					redirect_uri: window.location.origin,
					audience: 'https://dev-v00rtojo.us.auth0.com/api/v2/',
					scope: 'read:current_user update:current_user_metadata openid profile email',
					prompt: 'login select_account'
				}}>
				<React.StrictMode>
					<HelmetProvider>
						<ThemeProvider theme={theme}>
							<App />
						</ThemeProvider>
					</HelmetProvider>
				</React.StrictMode>
			</Auth0Provider>
		</GoogleOAuthProvider>
	</IPWhitelist>
);

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
	ReactDOM.hydrateRoot(rootElement, appTree);
} else {
	ReactDOM.createRoot(rootElement).render(appTree);
}
